export default __webpack_public_path__ + "static/media/foodieBooster06.25964908.png";